<template>
  <el-form :model="planForm" :rules="marketingGoalRules" :label-width="formLabelWidth" ref="maketing-goal">
    <el-form-item label="计划场景">
      <!-- 内部字段，无需提交到媒体 -->
      <el-radio-group v-model="planForm.ad_marketing_scene" :disabled="adMarketingSceneDisabled" @change="onAdMarketingSceneChange">
        <el-radio-button ghost :label="AD_MARKETING_SCENE.VERSION_3"> 腾讯3.0 </el-radio-button>
        <el-radio-button ghost :label="AD_MARKETING_SCENE.VERSION_SMART"> 腾讯-智投 </el-radio-button>
        <el-radio-button ghost :label="AD_MARKETING_SCENE.VERSION_SEARCH"> 搜索 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="投放场景" v-if="planForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART">
      <el-radio-group v-model="planForm.smart_delivery_platform">
        <el-radio-button v-if="platform.isMiniGame" ghost :label="SMART_DELIVERY_PLATFORM.MINI_GAME_PROMOTION">
          小游戏跑量
        </el-radio-button>
        <el-radio-button v-else ghost :label="SMART_DELIVERY_PLATFORM.GAME_APP"> 游戏应用智投 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="推广目的">
      <el-radio-group v-model="planForm.marketing_goal">
        <el-radio-button ghost :label="MARKETING_TYPE.USER_GROWTH"> 用户增长 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item
      label="子目的"
      prop="marketing_sub_goal"
      v-if="[AD_MARKETING_SCENE.VERSION_3, AD_MARKETING_SCENE.VERSION_SMART].includes(planForm.ad_marketing_scene)"
    >
      <el-radio-group v-model="planForm.marketing_sub_goal">
        <el-radio-button v-for="item in marketingSubGoalList" :key="item.value" ghost :label="item.value">
          {{ item.label }}
        </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="营销对象" prop="promotedObject">
      <el-radio-group v-model="planForm.marketing_carrier_type">
        <el-radio-button ghost :disabled="!platform.isIOS" :label="MARKETING_CARRIER_TYPE.APP_IOS"> IOS应用 </el-radio-button>
        <el-radio-button ghost :disabled="!platform.isAndroid" :label="MARKETING_CARRIER_TYPE.APP_ANDROID"> 安卓应用 </el-radio-button>
        <el-radio-button ghost :disabled="!platform.isMiniGame" :label="MARKETING_CARRIER_TYPE.MINI_GAME"> 微信小游戏 </el-radio-button>
      </el-radio-group>

      <PromotedObjectInput
        v-model="planForm"
        @change="onPromotedObjectChange"
        @clear="onPromotedObjectClear"
        style="margin-top: 10px; width: 240px"
      ></PromotedObjectInput>
    </el-form-item>

    <div v-show="planForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH">
      <el-form-item label="计划日预算" prop="daily_budget">
        <el-radio-group v-model="planForm.budget">
          <el-radio-button ghost :label="0">不限</el-radio-button>
          <el-radio-button ghost :label="1">设置日预算</el-radio-button>
        </el-radio-group>

        <div class="plan-budget" v-if="planForm.budget === 1">
          <el-input v-model="planForm.daily_budget" placeholder="此计划每日最高总花费"></el-input>
          <span>&ensp;每日预算50 - 40,000,000元</span>
        </div>
      </el-form-item>
      <el-form-item label="计划名称">
        <p>计划名称与计划名称一致</p>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import {
  PLATFORM,
  SMART_DELIVERY_PLATFORM,
  AD_MARKETING_SCENE,
  MARKETING_TYPE,
  MARKETING_SUB_GOAL,
  MINI_GAME_MARKETING_SUB_GOAL_LIST,
  MARKETING_SUB_GOAL_LIST,
  MARKETING_CARRIER_TYPE
} from '../../../model/project-const.js'
import PromotedObjectInput from '@/views/create/gdt/components/plan/promoted-object-input.vue'
import { marketingGoalRules } from '../../../model/project-rules.js'
export default {
  components: { PromotedObjectInput },
  props: {
    value: {
      type: Object
    },
    formLabelWidth: {
      type: String,
      default: '180px'
    }
  },
  inject: ['projectInstance'],
  data() {
    return {
      marketingGoalRules: marketingGoalRules.call(this),
      PLATFORM,
      MARKETING_TYPE,
      MARKETING_CARRIER_TYPE,
      SMART_DELIVERY_PLATFORM,
      AD_MARKETING_SCENE
    }
  },
  computed: {
    marketingSubGoalList() {
      return this.platform.isMiniGame ? MINI_GAME_MARKETING_SUB_GOAL_LIST : MARKETING_SUB_GOAL_LIST
    },
    planForm: {
      get() {
        return this.value
      },
      set(form) {
        this.$emit('input', form)
      }
    },
    platform() {
      return {
        isAndroid: this.planForm.ch_platform_id === PLATFORM.ANDROID,
        isIOS: this.planForm.ch_platform_id === PLATFORM.IOS,
        isMiniGame: this.planForm.ch_platform_id === PLATFORM.MINIGAME
      }
    },
    adMarketingSceneDisabled() {
      const { isDuplicate, isModify } = this.projectInstance.pageStates
      return isDuplicate || isModify
    }
  },
  created() {
    this.initEventBus()
  },
  methods: {
    initEventBus() {
      // platformChange 监听游戏平台变化
      this.$bus.$on('platformChange', this.onPlatformChange)
    },
    onAdMarketingSceneChange(e) {
      // 切换到智投时，根据平台判断取哪个投放场景【smart_delivery_platform】
      if (e === AD_MARKETING_SCENE.VERSION_SMART) {
        this.planForm.smart_delivery_platform = this.platform.isMiniGame
          ? SMART_DELIVERY_PLATFORM.MINI_GAME_PROMOTION
          : SMART_DELIVERY_PLATFORM.GAME_APP
      }
    },
    onPlatformChange(platform) {
      let marketing_carrier_type = MARKETING_CARRIER_TYPE.APP_ANDROID
      let smart_delivery_platform = SMART_DELIVERY_PLATFORM.MINI_GAME_PROMOTION
      if (platform === PLATFORM.MINIGAME) {
        marketing_carrier_type = MARKETING_CARRIER_TYPE.MINI_GAME
      }

      // 安卓iOS平台切换到多目标优化，小游戏切换到小游戏跑量
      if (this.planForm.ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART) {
        if (platform === PLATFORM.MINIGAME) {
          // todo
        } else {
          smart_delivery_platform = SMART_DELIVERY_PLATFORM.GAME_APP
        }
      }

      if (platform === PLATFORM.IOS) {
        marketing_carrier_type = MARKETING_CARRIER_TYPE.APP_IOS
      }
      this.planForm = {
        ...this.planForm,
        marketing_sub_goal:
          // 切换到小游戏平台时，推广子目的切换到【新客增长】，切换到app时，推广子目的切换到【平推期】
          platform === PLATFORM.MINIGAME ? MARKETING_SUB_GOAL.MINI_GAME_NEW_CUSTOMER_GROWTH : MARKETING_SUB_GOAL.PLATEAU_PHASE_LAUNCH,
        marketing_carrier_type,
        smart_delivery_platform
      }
    },
    onPromotedObjectChange() {
      this.clearValidate()
      this.projectInstance.doPlanFormClearValidate()
    },
    onPromotedObjectClear() {
      this.projectInstance.onClearPormotedObject()
    },
    formValidate() {
      return this.$refs['maketing-goal'].validate()
    },
    clearValidate() {
      this.$refs['maketing-goal'].clearValidate()
    }
  }
}
</script>

<style lang="scss" scoped>
.plan-budget {
  display: flex;
  margin-top: 6px;
  ::v-deep .el-input {
    width: 188px;
  }
  > span {
    font-size: 12px;
  }
}
</style>
